import { BUTTON_SIZE, BUTTON_TYPE, COLORS, DSButton } from '@repo/design-system/index'
import { n_landing } from '../../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import useLandingNav from '../useLandingNav'

const NavStart = () => {
  const { isSubNavVisible, handleStartClick } = useLandingNav()
  const { t } = useTranslation()

  return (
    <li>
      <DSButton
        size={BUTTON_SIZE.SM}
        type={isSubNavVisible ? BUTTON_TYPE.OUTLINE : BUTTON_TYPE.SOLID}
        onClick={handleStartClick}
      >
        <DSButton.Label customTxtColor={isSubNavVisible && COLORS.GRAY500}>
          {t(n_landing.sub_menu_1on1.btn_2)}
        </DSButton.Label>
      </DSButton>
    </li>
  )
}

export default NavStart
